<template>
 <div class="vue-tempalte">
     <div class="vertical-center">
        <div class="inner-block">
        <form>
            <h3>Sign Up</h3>
            <div class="form-group">
                <label>Full Name</label>
                <input type="text" id="username" value="" class="form-control form-control-lg"/>
            </div>
            <div class="form-group">
                <label>Email address</label>
                <input type="email" id="email" value="" class="form-control form-control-lg" />
            </div>
            <div class="form-group">
                <label>Password</label>
                <input type="password" id="password" value="" class="form-control form-control-lg" />
            </div>
            <button type="submit" @click.prevent="sSignup" class="btn btn-dark btn-lg btn-block">Sign Up</button>
            <p class="forgot-password text-right">
                Already registered 
                <router-link :to="{name: 'login'}">sign in?</router-link>
            </p>
        </form>
    </div>
     </div>
      </div>
</template>

<script>
import firebase from 'firebase';

export default {

  data(){
    return{
      
    }
  },
  methods:{

        sSignup: function(){
            //console.log(this.signupData.email+" "+this.signupData.password);
            var username = document.getElementById("username").value;
            var email = document.getElementById("email").value;
            var password = document.getElementById("password").value;

        firebase.auth().createUserWithEmailAndPassword(email, password).then(function(cred){
            // close the signup modal & reset form
            console.log(cred);

            
             const user = firebase.auth().currentUser;

                  user.updateProfile({
                    displayName: username,
                  }).then(() => {
                               
                    if(firebase.firestore().collection("Users").add(
                      {
                        username: username,
                        email: email,
                        password: password
                      }).then(()=>{
                      
                      })){
                        alert("account was created");
                      }
                  }).catch((error) => {
                     console.log(error.message);
                  });  

            
            document.getElementById("username").value = '';
            document.getElementById("email").value = '';
            document.getElementById("password").value = '';

        }, function(err){
            console.log(err.message);
        });
        }
    }
}
</script>

<style scoped>
* {
  box-sizing: border-box;
}
body {
  background: white !important;
  min-height: 100vh;
  display: flex;
  font-weight: 400;
}

body {
  background: white !important;
  min-height: 100vh;
  display: flex;
  font-weight: 400;
}
body,
html,
.App,
.vue-tempalte,
.vertical-center {
  width: 100%;
  height: 100%;
}
.navbar-light {
  background-color: #ffffff;
  box-shadow: 0px 14px 80px rgba(34, 35, 58, 0.2);
}
.vertical-center {
  display: flex;
  text-align: left;
  justify-content: center;
  flex-direction: column;    
}
.inner-block {
  width: 450px;
  margin: auto;
  background: #ffffff;
  box-shadow: 0px 14px 80px rgba(34, 35, 58, 0.2);
  padding: 40px 55px 45px 55px;
  border-radius: 15px;
  transition: all .3s;
}
.vertical-center .form-control:focus {
  border-color: #2554FF;
  box-shadow: none;
}
.vertical-center h3 {
  text-align: center;
  margin: 0;
  line-height: 1;
  padding-bottom: 20px;
}
label {
  font-weight: 500;
}
.forgot-password,
.forgot-password a {
  text-align: right;
  font-size: 13px;
  padding-top: 10px;
  color: #7a7a7a;
  margin: 0;
}
.forgot-password a {
  color: #2554FF;
}
.social-icons {
  text-align: center;
  font-family: "Open Sans";
  font-weight: 300;
  font-size: 1.5em;
  color: #222222;
}
.social-icons ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.social-icons ul li {
  display: inline-block;
  zoom: 1;
  width: 65px;
  vertical-align: middle;
  border: 1px solid #e3e8f9;
  font-size: 15px;
  height: 40px;
  line-height: 40px;
  margin-right: 5px;
  background: #f4f6ff;
}
.social-icons ul li a {
  display: block;
  font-size: 1.4em;
  margin: 0 5px;
  text-decoration: none;
}
.social-icons ul li a i {
  -webkit-transition: all 0.2s ease-in;
  -moz-transition: all 0.2s ease-in;
  -o-transition: all 0.2s ease-in;
  -ms-transition: all 0.2s ease-in;
  transition: all 0.2s ease-in;
}
.social-icons ul li a:focus i,
.social-icons ul li a:active i {
  transition: none;
  color: #222222;
}
</style>
